module.exports = __webpack_public_path__ + "d03716d2957766b3fa60619c11e8a950.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/autodesk_2022_chart.png
// module id = 1637
// module chunks = 0